import { createSelector } from 'reselect'

import { resolveMilestones } from '../utils/milestone';

const sort = (source, completedAtBottom) => source
    .sort((m1, m2) => {
        let m1Value = new Date(m1.start).getTime();
        let m2Value = new Date(m2.start).getTime();

        if (completedAtBottom) {
            if (new Date(m1.end) < new Date()) {
                // Completed
                m1Value = new Date(m1.end).getTime() + 10000000000000;
            }

            if (new Date(m2.end) < new Date()) {
                // Completed
                m2Value = new Date(m2.end).getTime() + 10000000000000;
            }
        }

        if (m1Value > m2Value) return 1;
        if (m1Value < m2Value) return -1;

        if (new Date(m1.created_at).getTime() > new Date(m2.created_at).getTime()) return 1;
        if (new Date(m1.created_at).getTime() < new Date(m2.created_at).getTime()) return -1;

        const m1Name = (m1.name && m1.name.toLowerCase());
        const m2Name = (m2.name && m2.name.toLowerCase());

        if (m1Name > m2Name) return 1;
        if (m1Name < m2Name) return -1;

        if (m1.id > m2.id) return 1;
        if (m1.id < m2.id) return -1;

        return 0;
    });

const getMilestone = (milestones, id) => milestones.find(milestone => milestone.id === id);
export const makeGetMilestone = () => createSelector(getMilestone, milestone => milestone);

const getResolvedMilestone = (milestones, id) => resolveMilestones([id], false, true)[0];
export const makeGetResolvedMilestone = () => createSelector(getResolvedMilestone, milestone => milestone);

const getSortedActiveMilestones = milestones => sort(milestones
    .filter(milestone => !milestone.removed && !milestone.archived))
    .map((milestone, index) => ({...milestone, order: index}));
export const makeGetSortedActiveMilestones = () => createSelector(getSortedActiveMilestones, milestones => milestones);

const getSortedActiveProjectMilestones = (milestones, projectId, excluded = []) => sort(milestones
    .filter(milestone => !milestone.removed && !milestone.archived && milestone.project === projectId && !excluded.includes(milestone.id)))
    .map((milestone, index) => ({...milestone, order: index}));
export const makeGetSortedActiveProjectMilestones = () => createSelector(getSortedActiveProjectMilestones, milestones => milestones);

const getSortedArchivedProjectMilestones = (milestones, projectId) => sort(milestones
    .filter(milestone => !milestone.removed && milestone.archived && milestone.project === projectId))
    .map((milestone, index) => ({...milestone, order: index}));
export const makeGetSortedArchivedProjectMilestones = () => createSelector(getSortedArchivedProjectMilestones, milestones => milestones);

const getAltSortedActiveProjectMilestones = (milestones, projectId) => sort(milestones
    .filter(milestone => !milestone.removed && !milestone.archived && milestone.project === projectId), true)
    .map((milestone, index) => ({...milestone, order: index}));
export const makeGetAltSortedActiveProjectMilestones = () => createSelector(getAltSortedActiveProjectMilestones, milestones => milestones);
